/** CoStar.Api.ConsumerUserData.Lookup.ReasonCodeType */
export var ReasonCodeType;
(function (ReasonCodeType) {
    ReasonCodeType[ReasonCodeType["None"] = 0] = "None";
    ReasonCodeType[ReasonCodeType["System"] = 1] = "System";
    ReasonCodeType[ReasonCodeType["Reject"] = 2] = "Reject";
    ReasonCodeType[ReasonCodeType["Suspicious"] = 3] = "Suspicious";
    ReasonCodeType[ReasonCodeType["Risk"] = 4] = "Risk";
    ReasonCodeType[ReasonCodeType["Obsolete"] = 5] = "Obsolete";
})(ReasonCodeType || (ReasonCodeType = {}));
/** CoStar.Api.ConsumerUserData.Lookup.ListingExclusionType */
export var ListingExclusionType;
(function (ListingExclusionType) {
    ListingExclusionType[ListingExclusionType["Unknown"] = 0] = "Unknown";
    ListingExclusionType[ListingExclusionType["All"] = 1] = "All";
    ListingExclusionType[ListingExclusionType["PaidListing"] = 2] = "PaidListing";
    ListingExclusionType[ListingExclusionType["NonpaidListing"] = 3] = "NonpaidListing";
    ListingExclusionType[ListingExclusionType["Move"] = 4] = "Move";
})(ListingExclusionType || (ListingExclusionType = {}));
/** CoStar.Api.ConsumerUserData.Lookup.ListingInclusionType */
export var ListingInclusionType;
(function (ListingInclusionType) {
    ListingInclusionType[ListingInclusionType["Unknown"] = 0] = "Unknown";
    ListingInclusionType[ListingInclusionType["All"] = 1] = "All";
    ListingInclusionType[ListingInclusionType["PaidListing"] = 2] = "PaidListing";
    ListingInclusionType[ListingInclusionType["NonpaidListing"] = 3] = "NonpaidListing";
    ListingInclusionType[ListingInclusionType["Move"] = 4] = "Move";
})(ListingInclusionType || (ListingInclusionType = {}));
